type Args = {
	accountId: number;
	limitId: number;
	monthlyAmount: number;
	alertThresholdPercent: number;
};

class UpdateAiCostLimit {
	readonly accountId: number;
	readonly limitId: number;
	readonly monthlyAmount: number;
	readonly alertThresholdPercent: number;

	constructor(args: Args) {
		this.accountId = args.accountId;
		this.limitId = args.limitId;
		this.monthlyAmount = args.monthlyAmount;
		this.alertThresholdPercent = args.alertThresholdPercent;

		Object.freeze(this);
	}

	// The level and the subject of a limit are immutable: the server refuses them in the body.
	toJSON(): Record<string, unknown> {
		return {
			monthlyAmount: this.monthlyAmount,
			alertThresholdPercent: this.alertThresholdPercent,
		};
	}
}

export default UpdateAiCostLimit;
